import React , { useState } from 'react';
import { IconX } from '@tabler/icons-react'; // Assuming you're using Tabler icons
import {UploadFileModal, WebsiteModal, ThirdPartyModal} from "@/components/dialog/UploadKnowledge"

interface KnowledgeDialogProps {
    isOpen: boolean;               // Indicates if the dialog is open
    onClose: () => void;           // Function to call when closing the dialog
    tags: any;                // Array of tags (assuming tags are strings)
    setTags: any; // State setter function for tags
    flowData: any;                 // Replace `any` with a more specific type if possible
    setFlowData: any; // State setter function for flowData
  }
  
const KnowledgeDialog: React.FC<KnowledgeDialogProps> = ({ isOpen, onClose, tags, setTags, flowData, setFlowData }) => {

    if (!isOpen) return null;

    const [uploadFileModalOpen, setUploadFileModalOpen] = useState(false);
    const [websiteModalOpen, setWebsiteModalOpen] = useState(false);
    const [thirdPartyModalOpen, setThirdPartyModalOpen] = useState(false);

    return (
        <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            {/* Background backdrop */}
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div className="flex h-screen items-end justify-center p-4 text-center sm:items-center sm:p-0">
        {/* Modal panel */}
        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl  p-6">
            {/* Close button */}
            <button
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
                onClick={onClose}
            >
                <IconX size={24} />
            </button>
            <h1 className='text-2xl font-semibold'>Teach the AI about a topic </h1>
            We'll create a data table that can be added to any tool or agent. Knowledge is used to provide context to the large language model.
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start space-x-4">
                    <button className="card-container w-2/4 p-4 bg-white shadow-lg rounded-lg large"
                     onClick={() => setUploadFileModalOpen(true)}
                    >
                        <div className="image-container relative">
                            <img src="/img/uploadKnowledge.jpg" alt="Upload file" className="w-full h-32 object-cover" />
                        </div>
                        <div className="content-container mt-4">
                            <h2 className="text-lg font-semibold">Upload file</h2>
                            <p className="text-sm text-gray-600">Upload any amount of PDF, CSV, Excel or audio files.</p>
                        </div>
                    </button>
                    <button className="card-container w-2/4 p-4 bg-white shadow-lg rounded-lg large"
                    onClick={() => setWebsiteModalOpen(true)}
                    >
                        <div className="image-container relative">
                            <img src="/img/websiteKnowlege.png" alt="Upload file" className="w-full h-32 object-cover"/>
                        </div>
                        <div className="content-container mt-4">
                            <h2 className="text-lg font-semibold">Website</h2>
                            <p className="text-sm text-gray-600">Crawl through Website and import text or HTML.</p>
                        </div>
                    </button>
                    {/* <button className="card-container w-1/3 p-4 bg-white shadow-lg rounded-lg large"
                    onClick={() => setThirdPartyModalOpen(true)}
                    >
                        <div className="image-container relative">
                            <img src="/img/thirdPartyKnowledge.svg" alt="Upload file"  className="w-full h-32 object-cover"/>
                        </div>
                        <div className="content-container mt-4">
                            <h2 className="text-lg font-semibold">Import from third-party</h2>
                            <p className="text-sm text-gray-600">Choose from our library of loader integrations.</p>
                        </div>
                    </button> */}
                </div>
            </div>
        </div>
    </div>
</div>

<UploadFileModal isOpen={uploadFileModalOpen} onClose={() => setUploadFileModalOpen(false)} tags={tags} setTags={setTags} closeKnowledgeModal={onClose} flowData={flowData} setFlowData={setFlowData} />
            <WebsiteModal isOpen={websiteModalOpen} onClose={() => setWebsiteModalOpen(false)} tags={tags} setTags={setTags} closeKnowledgeModal={onClose} />
            <ThirdPartyModal isOpen={thirdPartyModalOpen} onClose={() => setThirdPartyModalOpen(false)} tags={tags} setTags={setTags} closeKnowledgeModal={onClose}/>

        </div>
    );
};

export default KnowledgeDialog;
